export const HEALTH = {
  nickname: 'PRODUCTS.HEALTH.shortname',
  isHidden: true,
  icon:'health'
};
